'use strict';

import './search/searchField';
import './search/searchResults';

export default class Search extends HTMLElement {
    constructor() {
        super();
        this.searchField = this.querySelector('[is="vz-search-field"]');
        this.searchResults = this.querySelector('[is="vz-search-results"]');

        this.searchField.addEventListener('vz-search:results', (evt) => {
            this.searchResults.setAttribute('results', JSON.stringify(evt.detail));
        });
    }
}

if (!window.customElements.get('vz-search')) {
    customElements.define('vz-search', Search);
}
